import { FormGroup, Input, Label, Tooltip } from "reactstrap";
import { useThemeContext } from "../../Context/ThemeContext";
import { getDarkDropdown } from "../../Utils/otherFunctions";
import { forwardRef, useState, useEffect } from "react";
import { Info } from "react-feather";

const SelectionField = forwardRef(function SelectionField(props, ref) {
  const { 
    label, 
    placeholder, 
    options, 
    fieldState, 
    className, 
    optionStyle,
    onChange,
    value 
  } = props;
  
  const { themeContext } = useThemeContext();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  const disabled = props.disabled || options?.length <= 1;

  useEffect(() => {
    if (options?.length === 1 && onChange && !value) {
      onChange(options[0].id);
    }
  }, [options, onChange, value]);

  return (
    <FormGroup className={className}>
      {label && (
        <Label className={`bg-transparent`}>
          {label}{" "}
          {props.isRequired && (
            <font className="ml-1" color="red">
              *
            </font>
          )}
          {props.tooltip && <Info id={`tooltip-${props.name}`} size={10} />}
        </Label>
      )}
      <Input
        className={`${
          disabled && themeContext === "dark" && "bg-dark"
        } ${getDarkDropdown(themeContext)}`}
        style={{ border: "1px solid black" }}
        invalid={fieldState?.error}
        type="select"
        ref={ref}
        {...props}
      >
        {!options ? (
          <b>Ops, no one here yet</b>
        ) : (
          <>
            <option
              disabled={!props.emptyValue}
              selected={!value && options.length > 1}
              hidden={!props.emptyValue}
              value={""}
            >
              {placeholder || (disabled && "------")}
            </option>
            {options.map((option) => (
              <option
                disabled={option.disabled}
                value={option.id}
                key={option.id}
                selected={value === option.id || (options.length === 1 && !value)}
                style={
                  optionStyle
                    ? optionStyle[option.id % 2]
                    : { backgroundColor: "#ffffff" }
                }
              >
                {option.name}
              </option>
            ))}
          </>
        )}
      </Input>
      {fieldState?.error && (
        <Label className={"label-text text-danger"}>
          {fieldState.error.message}
        </Label>
      )}
      {props.tooltip && (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={`tooltip-${props.name}`}
          toggle={toggle}
        >
          {props.tooltip}
        </Tooltip>
      )}
    </FormGroup>
  );
});

export default SelectionField;